// extracted by mini-css-extract-plugin
module.exports = {"line":"text-module--line--F3Z2W","init":"text-module--init--31Hzy"};